<template>
    <div>
        <!-- new format meeting 12/02/2023-->
        <section ref="foldersBox" class="folders-section section py-5 px-5">
            <div v-if="selectedFilter == 'invited'">
                <section class="section px-0 py-5">
                    <div class="columns is-multiline is-mobile mx-0">
                        <div class="column is-12 pb-0">
                            <p class="is-size-4 is-capitalized">
                                {{ $t('projects_shared_with_me') }}
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <div v-else-if="selectedFilter == 'all'">
                <section class="section px-0 py-5">
                    <div class="columns is-multiline is-mobile mx-0">
                        <div class="column is-12 pb-0">
                            <p class="is-size-4 ">
                                {{ $t('projects_all') }}
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <div v-else-if="selectedFilter == 'access'">
                <section class="section px-0 py-5">
                    <div class="columns is-multiline is-mobile mx-0">
                        <div class="column is-12 pb-0">
                            <p class="is-size-4">
                                {{ $t('projects_all') }}
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <n-dashboard-folders
                v-if="selectedFilter == 'mine'"
                @addProject="addProjectToFolder"
                :createFolder="creatingFolder"
                @folderCreated="folderCreated"
                @folderUpdated="folderUpdated"
                @cancel="folderCreated"
                @create-folder="createFolder"
                class="pt-5"
            />
        </section>
        <section ref="searchBox" class="section pt-5 px-5 pb-6"
            v-if="!showNoProjects"
        >
            <!--<hr v-if="selectedFilter == 'mine'" />-->
            <div class="mx-3">
                <n-project-search-bar-with-filter
                    v-model="searchString"
                    :filters.sync="selectedType"
                    @change-filter="projectFilter"
                    :loading="loadingItems"
                    class=""
                />
            </div>
        </section>
        <section ref="contentBox" class="section pt-0" :class="showNoProjects?'px-0 pt-5':'px-5'">
            
            <n-dashboard-content
                ref="childComponent"
                :active-filter="selectedFilter"
                :items="projects"
                :loading="loadingItems"
                @delete="removeProject"
                @addProject="addProject"
                :totalProjects="schoolProjectsCount"
                @toggleHighlight="toggleHighlight"
            />
        </section>
    </div>
</template>

<script>
import AppSearchBarWithFilter from '@/components/AppSearchBarWithFilter';
import DashboardContent from '@/components/DashboardContent';
import NDashboardContent from '@/components/NDashboardContent';
import ExplorerFolderSection from '@/components/ExplorerFolderSection';
import NDashboardFolders from '@/components/NDashboardFolders';
import _ from 'underscore';
import { fetchItems, addProjectToFolder, fetchSchoolProjectsCount } from '@/services/API';
import ProjectSearchBarWithFilter from '@/components/ProjectSearchBarWithFilter';
import NProjectSearchBarWithFilter from '@/components/NProjectSearchBarWithFilter';
export default {
    components: {
        AppSearchBarWithFilter,
        DashboardContent,
        ExplorerFolderSection,
        ProjectSearchBarWithFilter,
        NProjectSearchBarWithFilter,
        NDashboardFolders,
        NDashboardContent,
    },
    data() {
        return {
            loadingItems: false,
            searchString: this.$route.query.search,
            selectedType: 'FILTER_OPTION_PROJECTS_ALL',
            selectedFilter: this.$route.query.filter,
            queryType: this.$route.query.type,
            items: [],
            projects: [],
            featuredProjects: [],
            currentPage: 1,
            limit: 24,
            offset: 0,
            lastPage: false,
            //availableProjectOptions: [this.$t('Constants.FILTER_OPTION_ALL'),this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'),this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED')],
            selectedProjectOption: this.$t('Constants.FILTER_OPTION_ALL'),
            filterOptions: this.$t('Constants.FILTER_OPTION_ALL'),
            filters: [],
            formats: undefined,
            updateFolders: false,
            creatingFolder: false,
            searching: false,
            schoolProjectsCount: 0,
        };
    },
    computed: {
        projectType() {
            if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_COLLECTIONS')
            ) {
                return 'collection,map';
            } else if (
                this.selectedType ==
                this.$t('Constants.FILTER_OPTION_PROJECTS_GAMES')
            ) {
                return 'trivial,treasurehunt,scape,memory,quizhunt';
            }
            return 'collection,trivial,treasurehunt,storytelling,scape,memory,quizhunt';
        },
        handleDebouncedScroll() {
            return _.debounce(this.handleScroll, 100);
        },
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        showNoProjects(){
            return this.selectedFilter === 'mine' && !this.projects.length && !this.searchString && this.selectedType=='FILTER_OPTION_PROJECTS_ALL'
        },
        isGuest() {
            let isGuest=false;
            if (this.isAdmin) {
                // console.log("isGuest? is admin",isGuest)
                return false;
            }
            if (this.$store.getters.user.entities) {
                // console.log("checking entities permissions")
                this.$store.getters.user.entities.forEach(element => {
                    // console.log(element.entity._id,this.$store.getters.user.school._id)
                    if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission == 'GUEST')) {
                        // console.log("is guest")
                        isGuest = true;
                    } /*else {
                        console.log("not guest")
                        isGuest = false;
                    }*/
                });
            } else {
                // console.log("not guest 2")
                isGuest = false;
            }
            console.log("isGuest?",isGuest)
            return isGuest;
            //return this.isAdmin
        }
    },
    watch: {
        '$route.query.filter': function (newValue) {
            if (newValue) {
                this.selectedFilter = newValue;
            }
        },
        '$route.query.type': function (newValue) {
            this.queryType = newValue;
        },
        '$route.query.search': function (newValue) {
            this.searchString = newValue;
            // console.log('newValue for text search', newValue);
        },
        /*'$store.getters.projectsNumber': function (newValue) {
            console.log('user project number', newValue);
            if()
        },*/
        
        selectedFilter: {
            handler: 'filterHandler',
            immediate: true,
        },
        searchString: {
            handler: 'searchStringHandler',
            immediate: false,
        },
        selectedType: {
            handler: 'typeHandler',
            immediate: false,
        },
        selectedProjectOption: {
            handler: 'projectOptionHandler',
            immediate: true,
        },
        filters: {
            handler: 'filtersHandler',
            immediate: false,
        },
        isGuest: {
            handler: 'checkGuest',
            immediate: false,
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleDebouncedScroll, true);
        /*console.log(this.isAdmin,this.$route.query.filter);
        if (this.$route.query.filter == 'all' && !this.isAdmin) {
            console.log("redirecting")
            this.$router.replace({ path: '/dashboard?filter=mine' })

        }*/
       
        if (this.$store.getters.hasSchool) { 
            // console.log("school",this.$store.getters.school)
            this.getSchoolProjectsCount();
        }

        
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    methods: {
        async getSchoolProjectsCount() {
            await fetchSchoolProjectsCount().catch((e) => { 
                console.log("error in fetch school projects count",e)
            }).then((response) => { 
                if (response.status == 200) {
                    // console.log("total school projects", response.data)
                    this.schoolProjectsCount = response.data
                }
            })
        },
        selectProject(project) {
            this.$refs.childComponent.selectProject(project);
        },
        async getItems() {
            // console.log("in getItems")
            if (this.$route.query.filter == 'all' && !this.isAdmin) {
                // console.log("redirecting 2")
                this.$router.replace({ path: '/dashboard?filter=mine' })
                return;
            }
            if (this.$route.query.filter != 'access' && this.isGuest) {
                // console.log("redirecting to my access")
                this.$router.replace({ path: '/dashboard?filter=access' })
                return;
            }
            if (this.$route.query.filter == 'access' && !this.isGuest) {
                // console.log("redirecting to my projects")
                this.$router.replace({ path: '/dashboard?filter=mine' })
                return;
            }
            if (this.loadingItems) {
                // another call is running
                return;
            }
            this.loadingItems = true;
            // console.log('offset send', this.offset);
            if (!this.searchString && this.selectedFilter == 'mySchool') {
                let responseFeatured = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        type_in: this.projectType,
                        _offset: 0,
                        _limit: 9999,
                        _featured: true,
                        _sort: 'order:asc',
                    }
                );
                this.featuredProjects = responseFeatured.data;
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                // console.log('items length before news', this.items.length);
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                // console.log('new offset to send ', this.offset);
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items.filter((item) => {
                    if (!item.featured) {
                        return item;
                    }
                });
            } else {
                // console.log('call in process');
                let response = await fetchItems(
                    `project/${this.selectedFilter}`,
                    {
                        title_contains: this.searchString,
                        description_contains: this.searchString,
                        owner_contains: this.searchString,
                        type_in: this.projectType,
                        format_in: this.formats,
                        _offset: this.offset,
                        _limit: this.limit,
                    }
                ).finally(() => {
                    this.loadingItems = false;
                    this.$emit('enableLinks');
                });
                this.items = this.items.concat(response.data);
                this.offset = this.items.length;
                if (response.data.length < this.limit) {
                    this.lastPage = true;
                }
                this.projects = this.items;
                if (
                    this.selectedProjectOption !=
                        this.$t('Constants.FILTER_OPTION_ALL') &&
                    this.selectedFilter == 'invited'
                ) {
                    this.projectOptionHandler();
                }
            }
            this.searching=false;
        },
        async removeProject(_id) {
            // console.log('removing item', _id);
            this.items = _.filter(this.items, (item) => {
                return item._id != _id;
            });
            if (this.projects.length > 0) {
                this.projects = _.filter(this.projects, (project) => {
                    return project._id != _id;
                });
            }
        },
        addProjectToFolder(project, folder) {
            let projectIndex = _.findIndex(this.projects, {
                _id: project,
            });
            const splicedProject = this.projects.splice(projectIndex, 1);
            addProjectToFolder(folder._id, { project }).catch(() => {
                this.projects.splice(projectIndex, 0, splicedProject[0]);
            });
        },
        filterHandler() {
            // console.log('in filter handler', this.selectedFilter);
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.$emit('disableLinks');
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ filter: this.selectedFilter } },
                })
                .catch((e) => {
                    //console.log('error selected filter');
                });
            this.resetSearch();
        },
        typeHandler() {
            this.searching = true;
            if (this.selectedType == 'FILTER_OPTION_ALL') {
                this.formats = undefined;
            } else {
                this.formats = this.selectedType;
            }
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.resetSearch();
        },
        searchStringHandler() {
            // console.log('searching', this.searchString);
            if (this.searchString && this.searchString.length == 0) {
                this.searchString = undefined;
            }
            // console.log('send', this.searchString);
            let query = Object.assign({}, this.$route.query);
            this.$router
                .push({
                    query: { ...query, ...{ search: this.searchString } },
                })
                .catch(() => {
                    console.log('error selected string');
                });
            this.resetSearch();
        },
        filtersHandler() {
            // console.log('filters', this.filters);
            this.projects = [];
            this.items = [];
            this.offset = 0;
            this.lastPage = false;
            this.$emit('disableLinks');
            if (this.filters.length < 1) {
                this.formats = undefined;
            } else {
                this.formats = this.filters.join();
            }
            this.resetSearch();
        },
        resetSearch() {
            this.offset = 0;
            this.lastPage = false;
            this.items = [];
            this.getItems();
        },
        handleScroll() {
            const { scrollHeight, clientHeight, scrollTop } =
                document.documentElement;
            const bottomOfWindow =
                (scrollHeight - 300 >= clientHeight + scrollTop) /
                    scrollHeight ==
                0;
            if (bottomOfWindow && !this.lastPage) {
                this.getItems();
            }
        },
        projectOptionHandler() {
            switch (this.selectedProjectOption) {
                case this.$t('Constants.FILTER_OPTION_ALL'):
                    this.projects = this.items;
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_PARTICIPATED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === true) {
                            return item;
                        }
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECTS_INVITED'):
                    this.projects = this.items.filter((item) => {
                        if (item.watching === false) {
                            return item;
                        }
                    });
                    break;
            }
        },
        addProject() {
            // console.log('dashboardProjects');
            this.resetSearch();
        },
        createFolder() {
            // console.log('creating folder');
            this.creatingFolder = true;
        },
        folderCreated() {
            // console.log('folder created');
            this.creatingFolder = false;
            this.$emit("folderCreated");
        },
        folderUpdated() {
            this.$emit("folderUpdated");
        },
        projectFilter(e){
            // console.log(e)
            this.selectedType=e;
        },
        toggleHighlight(project) {
            const updatedIndex = _.findIndex(this.items, {
                _id: project._id,
            });

            this.items.splice(updatedIndex, 1, project);
            // this.publicProjects.splice(updatedIndex, 1);
        },
        checkGuest() {
            if (this.$route.query.filter == 'all' && !this.isAdmin) {
                // console.log("redirecting 2")
                this.$router.replace({ path: '/dashboard?filter=mine' })
                return;
            }
            if (this.$route.query.filter != 'access' && this.isGuest) {
                // console.log("redirecting to my access")
                this.$router.replace({ path: '/dashboard?filter=access' })
                return;
            }
            if (this.$route.query.filter == 'access' && !this.isGuest) {
                // console.log("redirecting to my projects")
                this.$router.replace({ path: '/dashboard?filter=mine' })
                return;
            }
        }
    },
};
</script>

<style scoped>
.hide {
    visibility: hidden !important;
    height: 0px;
    width: 0px;
    overflow: hidden;
}
.show {
    height: auto;
    overflow: hidden;
}
.is-horizontally-centered {
    margin: 0 auto;
}
.lb-creation-object .icon.is-large {
    height: 10rem;
    width: 10rem;
}
.mdi-10r {
    font-size: 10rem;
}

.back-image{
    padding-top: 5rem;
    max-width: 45%;
}
</style>
